import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCategoryTbInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.1737 3.53516C2.75891 3.53516 0.800781 5.49325 0.800781 7.90799V11.1469C0.800781 11.7731 1.30852 12.2808 1.93471 12.2808H5.1737C5.79987 12.2808 6.30762 11.7731 6.30762 11.1469V4.66906C6.30762 4.0429 5.79988 3.53516 5.1737 3.53516Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.6782 3.83984C10.0308 3.83984 9.50586 4.33083 9.50586 4.93634V11.2005C9.50586 11.806 10.0308 12.297 10.6782 12.297H14.0268C14.6742 12.297 15.1991 11.806 15.1991 11.2005V8.06843C15.1991 5.73335 13.1747 3.83984 10.6782 3.83984Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00188 2.39844C8.27942 2.39844 8.5042 2.60869 8.5042 2.86828V5.76603L10.3176 7.07044C10.5373 7.22901 10.5788 7.52383 10.4092 7.72939C10.2403 7.93495 9.92512 7.97371 9.70472 7.81513L8.0018 6.59002L6.29888 7.81513C6.07911 7.97371 5.76328 7.93494 5.59437 7.72939C5.42546 7.52383 5.46627 7.22901 5.68604 7.07044L7.49939 5.76603V2.86828C7.49939 2.60869 7.72434 2.39844 8.00188 2.39844Z",
			fill: "current"
		})
	]
});
export default SvgCategoryTbInformation;
